export const IMPORT_LIMIT_5MB = 5 * 1024 * 1024;

export const CSV_FILE = 'csv';
